module.exports = __webpack_public_path__ + "img/globe.31acb45d.svg";